import { useEffect } from "react";

export default function Favicon({ href }) {
  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = `${href}?v=${Date.now()}`;
    } else {
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.type = "image/x-icon";
      newLink.href = `${href}?v=${Date.now()}`;
      document.head.appendChild(newLink);
    }
  }, [href]);

  return null;
}
